import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import LanguageSwitcher from "./Language-switch";
import FreeTrialButton from "../landing/FreeTrialButton";

const HeaderNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // highlight state for "login"
  const [loginSelected, setLoginSelected] = useState(false);

  const directToLandingPage = () => navigate("/");

  const handleGetStarted = () => {
    console.log("cccc")
    setLoginSelected(true);
    window.location.href = "/business/get-started";
  };

  const menuItems = [
    "about us",
    // "faq",
    "pricing",
    "demo",
    // "blog",
    "printing material",
    "contact",
    "login",
  ];

  return (
    <nav className="absolute top-0 left-0 w-full z-50 bg-transparent text-white">
      {/* Logo Section */}
      <div className="flex items-center justify-between px-4 sm:px-6 md:px-10 py-3">
        <div className="items-center gap-2 ml-1">
          <img
            src={logo}
            alt="Google Play"
            className="h-8 w-auto cursor-pointer ml-6 md:ml-2 lg-xl:ml-8 xl-2xl:ml-12"
            onClick={directToLandingPage}
          />
          <div className="tracking-[0.05rem] md:text-[16px] lg-xl:text-[18px] xl-2xl:text-[20px]">
            the out & about chat app
          </div>
          <span className="text-sm text-gray-200 hidden sm:block"></span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-10 lg:gap-16 ml-5">
          <ul className="flex items-center gap-6 md:gap-4 lg-xl:gap-4 xl-2xl:gap-10 text-sm lg:text-base font-medium">
            {menuItems.map((item) =>
              item === "login" ? (
                <li key={item}>
                  {/* LOGIN (desktop): highlightable, no navigation */}
                  <span
                    className={
                      loginSelected
                        ? "text-[#FCBA05] font-semibold cursor-default"
                        : "text-sm lg:text-base opacity-80 cursor-pointer hover:text-[#FCBA05] transition"
                    }
                    onClick={() => {
                      setLoginSelected(true);
                      window.location.href = "/business/login";
                    }}
                  >
                    login
                  </span>
                </li>
              ) : (
                <li key={item}>
                  <NavLink
                    to={`/${item.replace(/ /g, "")}`}
                    onClick={() => setLoginSelected(false)}
                    className={({ isActive }) =>
                      isActive
                        ? "text-[#FCBA05] font-semibold"
                        : "hover:text-[#FCBA05] transition"
                    }
                  >
                    {item}
                  </NavLink>
                </li>
              )
            )}
            <LanguageSwitcher />
          </ul>

          {/* Desktop Free Trial Button */}
          <span className="mt-0 ml-[-2rem]">
            <FreeTrialButton onClick={handleGetStarted} />
          </span>
        </div>

        {/* Mobile Menu Button */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden">
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden text-white flex flex-col items-center py-6 space-y-6 border-t border-white/10" style={{ backgroundColor: "#020013" }}>
          {menuItems.map((path, index) =>
            path === "login" ? (
              // LOGIN (mobile): highlightable, no navigation
              <span
                key={index}
                className={
                  loginSelected
                    ? "text-lg text-[#FCBA05] font-semibold cursor-default"
                    : "text-lg opacity-80 cursor-pointer hover:text-yellow-300 transition"
                }
                onClick={() => {
                  setLoginSelected(true);
                  window.location.href = "/business/login";
                }}
              >
                login
              </span>
            ) : (
              <NavLink
                key={index}
                to={`/${path.replace(/ /g, "")}`}
                onClick={() => {
                  setMenuOpen(false);
                  setLoginSelected(false);
                }}
                className="text-lg hover:text-yellow-300 transition"
              >
                {path.replace(/([A-Z])/g, " $1").toLowerCase()}
              </NavLink>
            )
          )}

          <LanguageSwitcher />

          <FreeTrialButton onClick={handleGetStarted} />
        </div>
      )}
    </nav>
  );
};

export default HeaderNavbar;
